/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';

export type KiteInternalTrxInfo = {
    BNO: string;
    AG: string;
    PTRXHA: string;
    STP: KiteInternalTrxInfo.STP;
    TMT: KiteInternalTrxInfo.TMT;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VA: string;
    UT: number;
};

export namespace KiteInternalTrxInfo {

    export enum STP {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }

    export enum TMT {
        CALL = 'CALL',
        CREATE = 'CREATE',
        CREATE2 = 'CREATE2',
        STATICCALL = 'STATICCALL',
        SELFDESTRUCT = 'SELFDESTRUCT',
        DELEGATECALL = 'DELEGATECALL',
        CALLCODE = 'CALLCODE',
    }


}

